import http from '../config/http';
import routes from '../config/api_routes';

export const getPartnerCategories = (page=1) => http(true).get(routes.partnerCategories.get.replace("pageNumber",page))
export const getById = (id, props = {}) => {
    var route = (routes.partnerCategories.byId||'').replace(':id', id);
    return http().get(route, {
        params: props
    });
}